<template>
    <div>
        <Header></Header>
        <div class="top-wrapper" >
            <div calss="container" >   
                <!-- ローディング画面         -->
                <!-- <div class="loader-wrap">
                <div class="loader">Loading...</div>
                </div> -->
                <!-- ログイン時にはフォームとログアウトボタンを表示 -->
                <div v-if="user.uid" key="login">
                    <!-- userオブジェクトのdisplaynameを表示 -->
                    <h1>RitsBookへようこそ！<br>{{ user.displayName }}さん</h1>
                    <!-- ボタンを押したらdoLogoutメソッドを実行 -->
                    <router-link to="/profile" class="mypage btn">マイページへ</router-link><br>
                    <button class="searching btn" @click="search()">教科書を探す</button><br>
                    <router-link to="/sell" class="selling btn">教科書を売る</router-link><br>
                </div>

                <!-- 新着図書9件を表示する -->
                <div class="contents">
                    <div class="searchResult"> 
                    <h1  class="newItems">新着商品</h1>
                    <ul>
                        <li v-for="item in newItems" :key="item.itemID">
                            <router-link :to="{name: 'itemDetail', params:{id: item.itemID}}" >
                                <figure class="relative">
                                  <img :src="item.img_url" @click="selected(item)">
                                  <figcaption class="abusolute"><p>{{item.price}}円</p></figcaption>
                                </figure>
                                <p v-if="item.isSold" class="sold">販売中</p>
                                <p v-else class="soldout">売り切れ</p>
                                <p>{{item.item}}</p>
                            </router-link>
                        </li>
                    </ul>
                </div>
                </div>
                
            </div>
            </div>
            <menu-bar class="menu-bar"></menu-bar>
            </div>
</template>

<script>
import firebase from "firebase"
import Header from '../components/Header.vue'
import MenuBar from '../components/MenuBar.vue'
import db from '../plugins/firestore'


// window.onload = function(){
//     const spinner = document.getElementById('loader-wrap');
//     spinner.classList.add('loaded');
// }

export default {
    name:'Landing',
    components:{
        Header, 
        MenuBar,
        },
    data() {
        return {
            backgroundImageSrc: require("@/assets/landing-background.png"),
            user: {},  // ユーザー情報
            newItems: [] //新着図書9件を入れておく配列
        }
    },
    //生成時にログインしているかどうかを確認
    created() {
      firebase.auth().onAuthStateChanged(user => {
        if(!user){
                this.$router.push({path: "/"})
            }else{
                this.user = user
            }
      })

      //新着図書を取得
      db.collection("textbooks")
      .orderBy("timestamp", "desc")
    //   .limit(9)
      .get()
      .then(snap => {
          const array = [];
          snap.forEach(doc => {
              const itemData = doc.data();
              itemData.itemID = doc.id;
              array.push(itemData);
          });
          this.newItems = array
      })


    },
    methods: {
        // //ログイン処理
        // doLogin() {
        //     const provider = new firebase.auth.GoogleAuthProvider()
        //     firebase.auth().signInWithPopup(provider)
        //     this.$router.push({path: "/landing"})
        // },
        // ログアウト処理
        doLogout() {
          firebase.auth().signOut()
        },
        // //登録画面へ
        // register(){
        //     this.$router.push({path: "/register"})
        // }

        //検索するを押したら、vuexで管理されている検索結果を消す処理
        search() {
            this.$store.dispatch('searchResult', '')
            this.$router.push({path: '/search'})
        },
        //商品画像がクリックされたら、vuexにその商品のIDを格納して、ItemDetail.vueからアクセスできるようにする。
        selected(item){
            this.$store.dispatch('selected', item)
        },
    },
}
</script>

<style scoped>
* {
    margin: 0; 
    padding: 0;
    box-sizing: border-box;
}

.contents {
    text-align: center;
    margin: 0 auto;
}

.container {
    width: 100%;
    padding: 0 15px;
    margin: 0 auto;
    text-align: center;
    /* background-image: url("~@/assets/landing-background.png");  */
}

.top-wrapper{
    padding: 50px 0px 100px 0px;
    text-align: center;
}


.top-wrapper h1{
    font-size: 40px;
    letter-spacing: 3px;
    margin: 15px 0;
}

.newItems {
    color: rgba(134, 124, 125);
}

.top-wrapper h2{
    font-size: 30px;
    letter-spacing: 3px;
    margin: 15px 0;
}

.sp_br{
    display: none;
}


.login {
    padding: 8px 24px;
    margin: 30px 0;
    color: white;
    background-color:rgba(255,0, 0, 0.9);
    display: inline-block;
    opacity: 0.8;
    border-radius: 4px;
    text-align: center;
}

.login:hover {
    background-color:rgba(255,0, 0, 1);
}

.register {
    background-color: rgba(53, 174, 243, 1);
}

.btn {
    font-size: 15px;
    padding-bottom: 8px;
    padding-top: 8px;
    width: 300px;
    /*margin: 4px 0;*/
    color: white;
    display: inline-block;
    opacity: 0.8;
    border-radius: 4px;
    text-align: center;
}

.mypage{
    background-color: rgb(9, 255, 0);
    margin-bottom: 15px;
    color: black;
}

.searching:hover {
    background-color:rgba(255,0, 0, 1);
}

.searching{
    background-color:rgba(255,0, 0, 0.9);
}

.selling{
    margin: 20px;
    background-color: rgba(53, 174, 243, 0.9);
}

.selling:hover{
    background-color: rgba(53, 174, 243, 1);
}

/* ローディングのcss */

/* .loader-wrap {
	position: fixed;
	display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: #fff;
}
.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: load7 1.8s infinite ease-in-out;
  animation: load7 1.8s infinite ease-in-out;
}
.loader {
  color: #ffffff;
  font-size: 10px;
  margin: 80px auto;
  position: relative;
  text-indent: -9999em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.loader:before,
.loader:after {
  content: '';
  position: absolute;
  top: 0;
}
.loader:before {
  left: -3.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.loader:after {
  left: 3.5em;
}
@-webkit-keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}
@keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
} */

/* ここまで */

/* 新着図書周りのCSS*/
.searchResult {
  text-align: center;
  margin: 0 auto;
}

.searchResult img {
    width: 200px;
    height: 200px;
    object-fit: cover;
}


.searchResult{
    margin: 20px auto;
    width: 55%;
}

.searchResult p{
  text-align: left;
}

ul {
    display: flex;
    list-style: none;
    flex-wrap: wrap;
}

li {
    margin: 10px;
    width: 200px;
    /* border-radius: 5px; */
    box-sizing: border-box;
    box-shadow: 0 0 5px #999;
}

.sold {
    margin-left: 5px;
    border-radius: 5px;
    padding: 0px 10px;
    color: white;
    width: 70px;
    background-color: rgba(255,0, 0, 1);
}

.soldout {
  margin-left: 5px;
  border-radius: 5px;
  padding: 0px 10px;
  color: white;
  width: 85px;
  background-color: rgb(200, 200, 200);
}

.relative {
  width: 200px;
  position: relative;
}

.abusolute {
  bottom: 15px;
  position: absolute;
  color: white;
  background-color: rgba(50, 50, 50, 0.7);
  border-radius: 0 15px 15px 0;
}

.abusolute p {
  font-size: 20px;
  padding: 0px 15px;
}

p {
  padding: 0 15px;
}

/* メニューバー */
.menu-bar {
    position: sticky;
    bottom: 0;
}

@media all and (max-width:670px){

    button {
        width: 100px;
    }

    .top-wrapper h1{
        font-size: 26px;
    }

    .top-wrapper h2{
        font-size: 20px;
    }

    .sp_br{
        display: inline;
    }

    .top-wrapper p{
        font-size: 14px;
    }

        .searchResult{
        width: 98%;
        margin-top: 20px auto;
    }

    li {
        width: 110px;
        margin: auto;
        margin-top: 10px;
    }
    
    p {
      font-size: 13px;
      padding: 0 10px;
    }

    .sold {
      width: 65px;
    }

    .soldout {
      width: 80px;
    }

    img {
        width: 110px!important;
        height: 110px!important;
        object-fit: cover;
    }

    .relative {
      width: 95px;
      position: relative;
    }

    .abusolute {
      bottom: 15px;
      position: absolute;
      color: white;
      background-color: rgba(50, 50, 50, 0.7);
      border-radius: 0 15px 15px 0;
    }

    .abusolute p {
      font-size: 13px;
    }
}

</style>